<template>
  <div>
    <NavBar />
    <div class="container-fluid mb-5">
      <b-overlay :show="loading" opacity="0.99">
        <b-modal
          size="xl"
          id="novo"
          hide-footer
          no-close-on-backdrop
          @show="clearCreateForm()"
        >
          <template v-slot:modal-title>Novo cliente</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <div class="col-md-4 pb-0 pt-0">
                    <LabelRequiredField label="Plano" />
                    <select v-model="plan_id" class="form-control">
                      <option value>Selecione...</option>
                      <option
                        v-for="plan in plans"
                        :key="plan.id"
                        :value="plan.id"
                      >
                        {{ plan.description }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 pb-0 pt-0">
                    <LabelRequiredField label="Razão social" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-4 pb-0 pt-0">
                    <label>Nome fantasia</label>
                    <input
                      type="text"
                      v-model="fantasy_name"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <LabelRequiredField label="CNPJ" />
                    <input
                      type="text"
                      v-mask="'##.###.###/####-##'"
                      v-model="cnpj"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <LabelRequiredField label="IE" />
                    <input type="text" v-model="ie" class="form-control" />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <LabelRequiredField label="1º Telefone" />
                    <input
                      type="text"
                      v-model="first_phone"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <label>2º Telefone</label>
                    <input
                      type="text"
                      v-model="second_phone"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-4 pb-0 pt-0">
                    <LabelRequiredField label="Endereço" />
                    <input type="text" v-model="address" class="form-control" />
                  </div>
                  <div class="col-md-2 pb-0 pt-0">
                    <LabelRequiredField label="Nº" />
                    <input
                      type="text"
                      v-model="num_address"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <label>Complemento</label>
                    <input
                      type="text"
                      v-model="complement"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <label>Bairro</label>
                    <input
                      type="text"
                      v-model="neighborhood"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <label>CEP</label>
                    <input
                      type="text"
                      v-mask="'#####-###'"
                      v-model="cep"
                      class="form-control"
                      @keyup="handleSearchCEP"
                    />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <label>Cidade</label>
                    <input type="text" v-model="city" class="form-control" />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <label>Estado</label>
                    <select v-model="uf_id" class="form-control">
                      <option value>Selecione...</option>
                      <option v-for="uf in ufs" :key="uf.id" :value="uf.id">
                        {{ uf.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <label>Região</label>
                    <input type="text" v-model="region" class="form-control" />
                  </div>
                  <div class="col-md-3 pb-0 pt-0">
                    <LabelRequiredField label="Status" />
                    <select v-model="status_rest_home_id" class="form-control">
                      <option value>Selecione...</option>
                      <option
                        v-for="status in status_rest_home"
                        :key="status.id"
                        :value="status.id"
                      >
                        {{ status.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <WarningRequiredFields />
                    <ErrorsMessages :errors="errors" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>

        <v-card class="p-3">
          <div class="row">
            <div class="col-md-6 pt-0 mt-0 pb-0 mb-0">
              <v-text-field
                outlined
                dense
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                hide-details
              />
            </div>
            <div class="col-md-6 pt-0 mt-0 pb-0 mb-0 text-right">
              <v-btn
                class="v-primary"
                @click="
                  errors = [];
                  $bvModal.show('novo');
                "
              >
                <span class="fa fa-plus"></span> Novo
              </v-btn>
            </div>
            <div class="col-md-12 pt-0 mt-0 pb-0 mb-0">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="ativo"
                  value="true"
                  v-model="ativo"
                  @change="getRestHomes"
                />
                <label class="form-check-label" for="ativo">ATIVO</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="inativo"
                  value="true"
                  v-model="inativo"
                  @change="getRestHomes"
                />
                <label class="form-check-label" for="inativo">INATIVO</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="bloqueado"
                  value="true"
                  v-model="bloqueado"
                  @change="getRestHomes"
                />
                <label class="form-check-label" for="bloqueado"
                  >BLOQUEADO</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="finance"
                  value="true"
                  v-model="finance"
                  @change="getRestHomes"
                />
                <label class="form-check-label" for="finance"
                  >APENAS FINANCEIRO</label
                >
              </div>
            </div>
          </div>
        </v-card>

        <v-card class="p-3 mt-2">
          <div class="row">
            <div class="col-md-4 pt-0 mt-0 pb-0 mb-0">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="all"
                  value="true"
                  v-model="allRestHomesToCharge"
                  @change="handleSelectRestHomesToCharge"
                />
                <label class="form-check-label" for="all"
                  >SELECIONAR TODOS PARA IMPRIMIR</label
                >
              </div>
            </div>
          </div>
          <div class="row" v-if="restHomesToCharge.length > 0">
            <div class="col-md-4 pt-0 mt-0 pb-0 mb-0">
              <v-select
                label="Ano"
                outlined
                dense
                v-model="year"
                @change="yearChange"
                :items="p_years"
              />
            </div>
            <div class="col-md-4 pt-0 mt-0 pb-0 mb-0">
              <v-select
                label="Mês"
                outlined
                dense
                v-model="month"
                @change="monthChange"
                :items="p_months"
              >
                <template v-slot:item="{ item }">
                  {{ months[item].name }}
                </template>
                <template v-slot:selection="{ item }">
                  {{ months[item].name }}
                </template>
              </v-select>
            </div>
            <div class="col-md-4 pt-0 mt-0 pb-0 mb-0">
              <v-select
                label="Período"
                outlined
                dense
                v-model="charge_period"
                item-text="period_start"
                item-value="period_start"
                @change="monthChange"
                :items="p_periods"
              >
                <template v-slot:item="{ item }">
                  {{ padding(new Date(item.period_start).getDate()) }}-{{
                    new Date(item.period_end).toLocaleDateString()
                  }}
                </template>
                <template v-slot:selection="{ item }">
                  {{ padding(new Date(item.period_start).getDate()) }}-{{
                    new Date(item.period_end).toLocaleDateString()
                  }}
                </template>
              </v-select>
            </div>
            <div class="col-md-12 pt-0 mt-0 pb-0 mb-0 text-right">
              <button
                v-if="restHomesToCharge.length > 0"
                class="btn btn-certified"
                @click="printRestHomesToCharge"
              >
                IMPRIMIR SELECIONADOS
              </button>
            </div>
          </div>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="restHomes"
          :search="search"
          class="elevation-6 mt-2"
          :footer-props="{
            'items-per-page-options': [100, 200, 300],
            'items-per-page-text': 'Mostrar',
          }"
        >
          <template v-slot:[`item.charge`]="{ item }">
            <div class="form-check form-check-inline m-0">
              <input
                class="form-check-input"
                type="checkbox"
                id="ativo"
                :value="item.id"
                v-model="restHomesToCharge"
              />
            </div>
          </template>
          <template v-slot:[`item.logo_url`]="{ item }">
            <img v-if="item.logo_url" :src="item.logo_url" class="logo" />
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <a @click="handleClickRowTable(item)">{{ item.name }}</a>
          </template>
          <template v-slot:[`item.city_uf`]="{ item }">
            {{ item.city }}
          </template>
          <template v-slot:[`item.uf_initials`]="{ item }">
            {{ item.uf_initials }}
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";

import LabelRequiredField from "../templates/components/LabelRequiredField";

import ErrorsMessages from "../templates/components/ErrorsMessages";

import NavBar from "../templates/NavBar";

import routes from "../routes";

import toast from "../components/ToastNotification";

import api from "../services/api";

import apiCep from "../services/apiCep";

export default {
  name: "RestHomes",

  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      periods: {},
      p_years: [],
      p_months: [],
      p_periods: [],

      years: [],
      year: null,

      months: [
        { name: "JANEIRO", value: 0 },
        { name: "FEVEREIRO", value: 1 },
        { name: "MARÇO", value: 2 },
        { name: "ABRIL", value: 3 },
        { name: "MAIO", value: 4 },
        { name: "JUNHO", value: 5 },
        { name: "JULHO", value: 6 },
        { name: "AGOSTO", value: 7 },
        { name: "SETEMBRO", value: 8 },
        { name: "OUTUBRO", value: 9 },
        { name: "NOVEMBRO", value: 10 },
        { name: "DEZEMBRO", value: 11 },
      ],

      month: 1,
      charge_period: 1,
      period_span: null,
      payment_span: null,

      allRestHomesToCharge: false,
      restHomesToCharge: [],

      ativo: true,
      inativo: false,
      bloqueado: false,
      finance: false,

      errors: [],

      search: "",

      headers: [
        { text: "", value: "charge", sortable: false },
        { text: "Logo", value: "logo_url", sortable: false },
        { text: "#", value: "id", sortable: false },
        { text: "CNPJ", value: "cnpj", sortable: false },
        { text: "Plano", value: "plan_name", sortable: false },
        { text: "Nome", value: "name", sortable: false },
        { text: "Cidade", value: "city_uf", sortable: false },
        { text: "Estado", value: "uf_initials", sortable: false },
      ],

      ufs: [],

      plans: [],

      status_rest_home: [],

      plan_id: "",
      status_rest_home_id: "",
      uf_id: "",
      name: "",
      fantasy_name: "",
      cnpj: "",
      ie: "",
      address: "",
      num_address: "",
      complement: "",
      neighborhood: "",
      first_phone: "",
      second_phone: "",
      cep: "",
      city: "",
      region: "",

      restHomes: [],

      loadingCreate: false,
      loading: true,
    };
  },

  async created() {
    await this.getRestHomes();
    await this.getStatusRestHome();
    await this.getPlans();
    await this.getUfs();
    await this.getPeriodsAll();
  },

  methods: {
    handleSelectRestHomesToCharge() {
      this.restHomesToCharge = [];
      if (this.allRestHomesToCharge) {
        this.restHomesToCharge = this.restHomes.map((restHome) => restHome.id);
      }
    },

    handleClickRowTable(item) {
      this.handleToDetails(item);
    },

    handleSearchCEP: async function (e) {
      let _cep = e.target.value;

      if (_cep) {
        if (_cep.length == 9) {
          const response = await apiCep.get(`/${_cep}/json`);

          if (response.data.erro) {
            toast("CEP inválido", "error");
          } else {
            const { cep, logradouro, bairro, complemento, uf, localidade } =
              response.data;

            const { ufs } = this;

            ufs.map((u) => {
              if (u.initials == uf) {
                this.uf_id = u.id;
              }
            });

            this.cep = cep;
            this.address = logradouro;
            this.neighborhood = bairro;
            this.city = localidade;
            this.complement = complemento;
          }
        }
      }
    },

    async getRestHomes(page = 1) {
      try {
        this.loading = true;

        let { ativo, inativo, bloqueado, finance } = this;

        const response = await api.get("/admin/rest-home/paginate", {
          params: { page, ativo, inativo, bloqueado, finance },
        });

        const { restHomes } = response.data;

        this.restHomes = restHomes;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async getPlans() {
      try {
        const response = await api.get("/admin/plan/all");

        const { plans } = response.data;

        this.plans = plans;
      } catch (error) {
        console.log(error);
      }
    },

    async getStatusRestHome() {
      try {
        const response = await api.get("/admin/rest-home/status/all");

        const { status } = response.data;

        this.status_rest_home = status;
      } catch (error) {
        console.log(error);
      }
    },

    async getUfs() {
      try {
        const response = await api.get("/ufs");

        const { ufs } = response.data;

        this.ufs = ufs;
      } catch (error) {
        console.log(error);
      }
    },

    async clearCreateForm() {
      this.plan_id = "";
      this.status_rest_home_id = "";
      this.uf_id = "";
      this.name = "";
      this.fantasy_name = "";
      this.cnpj = "";
      this.ie = "";
      this.address = "";
      this.num_address = "";
      this.complement = "";
      this.neighborhood = "";
      this.first_phone = "";
      this.second_phone = "";
      this.cep = "";
      this.city = "";
      this.region = "";
    },

    async create(event) {
      event.preventDefault();

      this.loadingCreate = true;

      try {
        const {
          plan_id,
          status_rest_home_id,
          uf_id,
          name,
          fantasy_name,
          cnpj,
          ie,
          address,
          num_address,
          complement,
          neighborhood,
          first_phone,
          second_phone,
          cep,
          city,
          region,
        } = this;

        let params = {
          plan_id,
          status_rest_home_id,
          uf_id,
          name,
          fantasy_name,
          cnpj,
          ie,
          address,
          num_address,
          complement,
          neighborhood,
          first_phone,
          second_phone,
          cep,
          city,
          region,
        };

        const response = await api.post("/admin/rest-home/create", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.clearCreateForm();

          this.getRestHomes();

          this.errors = [];

          toast(message, "success");

          this.$bvModal.hide("novo");
        } else {
          this.errors = errors;
        }

        this.loadingCreate = false;
      } catch (error) {
        this.loadingCreate = false;
        console.log(error);
      }
    },

    handleToDetails: ({ id }) =>
      routes.push({ name: "client", params: { id } }),

    async getPeriodsAll() {
      try {
        let response = await api.get("/admin/rest-home/charge/periods-all");

        let { periods } = response.data;

        this.periods = periods;

        this.p_years = Object.keys(this.periods);
        this.year = this.p_years[this.p_years.length - 1];

        this.p_months = Object.keys(this.periods[this.year]);
        this.month = this.p_months[this.p_months.length - 1];

        this.p_periods = this.periods[this.year][this.month];
        this.charge_period =
          this.p_periods[this.p_periods.length - 1].period_start;
      } catch (error) {
        console.log(error);
      }
    },

    async yearChange() {
      this.p_months = Object.keys(this.periods[this.year]);
      this.month = this.p_months[this.p_months.length - 1];
      await this.monthChange();
    },

    async monthChange() {
      this.p_periods = this.periods[this.year][this.month];
      this.charge_period =
        this.p_periods[this.p_periods.length - 1].period_start;
    },

    padding(n) {
      return n < 10 ? `0${n}` : String(n);
    },

    printRestHomesToCharge() {
      let { restHomesToCharge, year, month, charge_period } = this;

      if (restHomesToCharge.length == 0) {
        return;
      }

      let ids = restHomesToCharge.join(",");

      let route = this.$router.resolve({
        name: "rest_homes_print_charge",
        params: {
          ids,
          year,
          month,
          charge_period,
        },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style>
.v-data-table table tr td {
  font-size: 12px !important;
}

.logo {
  padding: 2px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: solid 1px #ccc;
  object-fit: contain !important;
  margin: 2px;
}
</style>

